export const TOPDEALS_LIST = "TOPDEALS_LIST";
export const TOPDEALS_LIST_FAILED = "TOPDEALS_LIST_FAILED";
export const TOPDEALS_LIST_SUCCESS = "TOPDEALS_LIST_SUCCESS";
